import { render, staticRenderFns } from "./UiUserItem.vue?vue&type=template&id=3238355f&"
import script from "./UiUserItem.vue?vue&type=script&lang=js&"
export * from "./UiUserItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports